import { InjectionToken } from "@angular/core";

export const SOFTLINE_SETTINGS_DEVELOPER = 'developer';

export const SOFTLINE_CONST_DEFAULT_DEVELOPER_PASSWORD = 'mynameismethos'
export const SOFTLINE_CONFIG_DEVELOPER_PASSWORD = new InjectionToken<string>('SOFTLINE_CONFIG_DEVELOPER_PASSWORD', {
  providedIn: 'root',
  factory: () => {
    return SOFTLINE_CONST_DEFAULT_DEVELOPER_PASSWORD
  }
});
